// extracted by mini-css-extract-plugin
export default {"error_ico":"style__error_ico__HI2YR"};